import { useState, type FormEvent } from "react";
import { Banner } from "../components/ui";

/**
 * The one screen both audiences share, parameterised by copy.
 *
 * There is no "forgot my key" flow and there deliberately isn't one: keys are
 * stored as digests and cannot be recovered, only reissued from the admin
 * panel. Saying so here is kinder than a reset link that goes nowhere.
 */
export default function Login({
  title,
  blurb,
  fieldLabel,
  placeholder,
  error,
  busy,
  onSubmit,
  footer,
}: {
  title: string;
  blurb: string;
  fieldLabel: string;
  placeholder: string;
  error?: string | null;
  busy?: boolean;
  onSubmit: (secret: string) => void;
  footer?: React.ReactNode;
}) {
  const [secret, setSecret] = useState("");

  function submit(event: FormEvent) {
    event.preventDefault();
    const trimmed = secret.trim();
    if (trimmed) onSubmit(trimmed);
  }

  return (
    <div className="login">
      <h1>{title}</h1>
      <p className="lead">{blurb}</p>

      {error ? <Banner tone="error">{error}</Banner> : null}

      <form className="card" onSubmit={submit}>
        <label className="field">
          <span>{fieldLabel}</span>
          <input
            type="password"
            value={secret}
            onChange={(e) => setSecret(e.target.value)}
            placeholder={placeholder}
            autoComplete="off"
            autoFocus
            spellCheck={false}
          />
        </label>
        <button type="submit" className="primary" disabled={busy || !secret.trim()}>
          {busy ? "Checking…" : "Continue"}
        </button>
      </form>

      {footer ? <div className="switcher">{footer}</div> : null}
    </div>
  );
}
